import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { NumeracionesController } from './numeraciones.controller';
import { NumeracionesLookupController } from './numeraciones-lookup.controller';
import { NumeracionesService } from './numeraciones.service';

@Module({
  imports: [PrismaModule],
  controllers: [NumeracionesController, NumeracionesLookupController],
  providers: [NumeracionesService],
  exports: [NumeracionesService],
})
export class NumeracionesModule {}
